import React, { useState, useEffect } from "react";
import fit_tree_icon from "./../../assets/images/fit_tree_to_page.png";
import bubbleIcon from "./../../assets/images/bubble_map.png";
import mapIcon from "./../../assets/images/map.png";
import normal_tree_view from "./../../assets/images/tree_icon.png";
import dragIcon from "./../../assets/images/drag.png";
import bioTreeIcon from "./../../assets/images/biological.png"; // 🔁 Replace with your actual bio tree icon
import { sendEventToFlutter } from "./FamilyTree";

const ModeToggleButton = ({ member_id, setExpanded = null, expanded = null, mode: externalMode, isBefore: isBefore, hasExceededLimit: hasExceededLimit, DownloadSubscriber: DownloadSubscriber, fitTree: fitTree }) => {
  const [mode, setMode] = useState(externalMode ?? 0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dragEnabled, setDragEnabled] = useState(false);

  useEffect(() => {
    if (externalMode !== undefined) setMode(externalMode);
  }, [externalMode]);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent("toggleDrag", { detail: dragEnabled }));
  }, [dragEnabled]);

  const modes = [
    {
      title: "bubble view",
      icon: bubbleIcon,
      mode: 2,
      action: () => {
        const el = document.querySelector("g.card-authenticated");
        const selectedMemberId = el?.getAttribute("data-id");
        sendEventToFlutter("bubble_view", { "d": { "data": { "id": selectedMemberId } }, "isBefore": isBefore }, {
          mode: 2
        });
      },
      bgColor: "#0b8ab7",
    },
    {
      title: "map view",
      icon: mapIcon,
      mode: 3,
      action: () => {
        let currentURL = window.location.href;
        let urlParts = currentURL.split("/");
        let memberId = urlParts[urlParts.indexOf("mindmap") + 1];
        const el = document.querySelector("g.card-authenticated");
        const selectedMemberId = el?.getAttribute("data-id");
        sendEventToFlutter("map_view", { "d": { "data": { "id": memberId && memberId !== 'http:' && memberId !== 'https:' ? memberId : selectedMemberId } }, "isBefore": isBefore }, {
          mode: 3
        });
      },
      bgColor: "#0b8ab7",
    },
  ];

  const dragButton = {
    title: dragEnabled ? "Disable Drag" : "Enable Drag",
    icon: dragIcon,
    action: () => setDragEnabled(prev => !prev),
    get bgColor() {
      return dragEnabled ? "#e53935" : "#0b8ab7";
    },
  };

  const fitTreeButton = {
    title: "Fit Tree to Page",
    icon: fit_tree_icon,
    action: () => {
      if (setExpanded) setExpanded(!expanded);
      if (mode !== 0 && mode !== 3) {
        const el = document.querySelector("g.card-authenticated");
        const selectedMemberId = el?.getAttribute("data-id");
        sendEventToFlutter("tree_view", { "d": { "data": { "id": selectedMemberId } }, "isBefore": isBefore }, {
          mode: 0
        });
      }
    },
    bgColor: "#0b8ab7",
  };

  // ✅ New biological tree button
// ✅ New biological tree button
const bioTreeButton = {
  title: "Biological Tree View",
  icon: bioTreeIcon,
  mode: 4,
  action: () => {
    const el = document.querySelector("g.card-authenticated");
    const selectedMemberId = el?.getAttribute("data-id");
    if (selectedMemberId) {
      sendEventToFlutter("biological_tree_view", { "d": { "data": { "id": selectedMemberId } }, "isBefore": isBefore }, {
          mode: 4
        });
     // window.location.href = `/biologicalTree/${selectedMemberId}`;
    }
  },
  bgColor: "#0b8ab7",
};

  const renderButton = (btn, marginTop = "10px", extraProps = {}) => (
    <button
      key={btn.title}
      onClick={btn.action}
      title={btn.title}
      style={{
        backgroundColor: btn.bgColor,
        borderRadius: "50%",
        width: "40px",
        height: "40px",
        border: "none",
        cursor: "pointer",
        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "5px",
        marginTop,
      }}
      {...extraProps}
    >
      <img
        src={btn.icon}
        alt={btn.title}
        style={{ width: "70%", height: "70%", objectFit: "contain" }}
      />
    </button>
  );

  return (
    <div
      style={{
        position: "fixed",
        top: "70px",
        right: "20px",
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* Main toggle button */}
      <button
        className="toggle-btn"
        onClick={() => {
          setMenuOpen((prev) => !prev);
          console.log(mode);
          if (mode != 0) {
            const el = document.querySelector("g.card-authenticated");
            const selectedMemberId = el?.getAttribute("data-id");
            sendEventToFlutter(
              "tree_view",
              { d: { data: { id: selectedMemberId } }, isBefore: isBefore },
              { mode: 0 }
            );
          }
        }}
        title="Normal Tree View"
        style={{
          backgroundColor: "#0b8ab7",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          border: "none",
          cursor: "pointer",
          boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={normal_tree_view}
          alt="Normal Tree"
          style={{ width: "70%", height: "70%", objectFit: "contain" }}
        />
      </button>

      {menuOpen && (
        <>
          {!fitTree && DownloadSubscriber && !hasExceededLimit ? (
            <>
              {renderButton(dragButton, "45px")}
              {/* ✅ Bio tree button shown in restricted mode too */}
              {renderButton(bioTreeButton)}
            </>
          ) : (
            <>
              {renderButton(dragButton, "45px")}
              {renderButton(fitTreeButton)}
              {modes.map((m) =>
                renderButton(
                  { ...m, action: () => { m.action(); setMode(m.mode); setMenuOpen(false); } }
                )
              )}
              {/* ✅ Bio tree button at the bottom */}
              {false && renderButton({
                ...bioTreeButton,
                action: () => {
                  bioTreeButton.action();
                  setMode(4);
                  setMenuOpen(false);
                }
              })}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ModeToggleButton;